import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppRoutePath } from '../route-translation';
import { Country } from '../models';

@Injectable({ providedIn: 'root' })
export class CountryInfoService {
	private readonly translationService = inject(TranslateService);
	public readonly countryList: Country[] = [
		{
			key: 'egypt',
			name: 'country.egypt.title',
			description: 'country.egypt.subtitle',
			route: [AppRoutePath.Tours, this.translationService.instant('route.country.egypt')],
			image: 'images/countries/egypt.png',
		},
		{
			key: 'greece',
			name: 'country.greece.title',
			description: 'country.greece.subtitle',
			route: [AppRoutePath.Tours, this.translationService.instant('route.country.greece')],
			image: 'images/countries/greece.png',
		},
		{
			key: 'cyprus',
			name: 'country.cyprus.title',
			description: 'country.cyprus.subtitle',
			route: [AppRoutePath.Tours, this.translationService.instant('route.country.cyprus')],
			image: 'images/countries/cyprus.png',
		},
		{
			key: 'malta',
			name: 'country.malta.title',
			description: 'country.malta.subtitle',
			route: [AppRoutePath.Tours, this.translationService.instant('route.country.malta')],
			image: 'images/countries/malta.png',
		},
		{
			key: 'spain',
			name: 'country.spain.title',
			description: 'country.spain.subtitle',
			route: [AppRoutePath.Tours, this.translationService.instant('route.country.spain')],
			image: 'images/countries/spain.png',
		},
		{
			key: 'tunisia',
			name: 'country.tunisia.title',
			description: 'country.tunisia.subtitle',
			route: [AppRoutePath.Tours, this.translationService.instant('route.country.tunisia')],
			image: 'images/countries/tunisia.png',
		},
		{
			key: 'turkey',
			name: 'country.turkey.title',
			description: 'country.turkey.subtitle',
			route: [AppRoutePath.Tours, this.translationService.instant('route.country.turkey')],
			image: 'images/countries/turkey.png',
		},
		{
			key: 'uae',
			name: 'country.uae.title',
			description: 'country.uae.subtitle',
			route: [AppRoutePath.Tours, this.translationService.instant('route.country.uae')],
			image: 'images/countries/uae.png',
		},
	];
}
